module.exports = __webpack_public_path__ + "img/ring_g_i_1_1.99b23c2a.png";